import { some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export function tryGetRememberMe() {
    try {
        let _arg;
        const value = localStorage.getItem("kundeweb-remember-me");
        _arg = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(string_type, undefined, undefined)), value);
        return (_arg.tag === 0) ? _arg.fields[0] : undefined;
    }
    catch (e) {
        console.error(some("[LocaleStorage] Error getting locale storage item:"), e.message);
        return undefined;
    }
}

export function storeRememberMe(username) {
    try {
        const x = toString(4, Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(username));
        localStorage.setItem("kundeweb-remember-me", x);
    }
    catch (matchValue) {
    }
}

export function deleteRememberMe() {
    try {
        localStorage.removeItem("kundeweb-remember-me");
    }
    catch (matchValue) {
    }
}

